// extracted by mini-css-extract-plugin
export default {"main":"Provider_main__GX67P","loginCard":"Provider_loginCard__UyMR6","registerDiv":"Provider_registerDiv__lIkL0","loginForm":"Provider_loginForm__2TQ4T"};